<ng-template #mapComponentElem></ng-template>
